import AbstractValidator from './AbstractValidator';

const sepaCountries = [
    'AT', 'BE', 'BG', 'CY', 'CZ', 'DK', 'FO', 'GL', 'EE', 'FI', 'FR', 'DE',
    'GI', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'MC',
    'NL', 'NO', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'CH', 'GB', 'SM',
    'HR',
];

const ibanRegex = {
    AD: 'AD[0-9]{2}[0-9]{4}[0-9]{4}[A-Z0-9]{12}',
    AE: 'AE[0-9]{2}[0-9]{3}[0-9]{16}',
    AL: 'AL[0-9]{2}[0-9]{8}[A-Z0-9]{16}',
    AT: 'AT[0-9]{2}[0-9]{5}[0-9]{11}',
    AZ: 'AZ[0-9]{2}[A-Z]{4}[A-Z0-9]{20}',
    BA: 'BA[0-9]{2}[0-9]{3}[0-9]{3}[0-9]{8}[0-9]{2}',
    BE: 'BE[0-9]{2}[0-9]{3}[0-9]{7}[0-9]{2}',
    BG: 'BG[0-9]{2}[A-Z]{4}[0-9]{4}[0-9]{2}[A-Z0-9]{8}',
    BH: 'BH[0-9]{2}[A-Z]{4}[A-Z0-9]{14}',
    BR: 'BR[0-9]{2}[0-9]{8}[0-9]{5}[0-9]{10}[A-Z][A-Z0-9]',
    BY: 'BY[0-9]{2}[A-Z0-9]{4}[0-9]{4}[A-Z0-9]{16}',
    CH: 'CH[0-9]{2}[0-9]{5}[A-Z0-9]{12}',
    CR: 'CR[0-9]{2}[0-9]{3}[0-9]{14}',
    CY: 'CY[0-9]{2}[0-9]{3}[0-9]{5}[A-Z0-9]{16}',
    CZ: 'CZ[0-9]{2}[0-9]{20}',
    DE: 'DE[0-9]{2}[0-9]{8}[0-9]{10}',
    DO: 'DO[0-9]{2}[A-Z0-9]{4}[0-9]{20}',
    DK: 'DK[0-9]{2}[0-9]{14}',
    EE: 'EE[0-9]{2}[0-9]{2}[0-9]{2}[0-9]{11}[0-9]{1}',
    ES: 'ES[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{1}[0-9]{1}[0-9]{10}',
    FI: 'FI[0-9]{2}[0-9]{6}[0-9]{7}[0-9]{1}',
    FO: 'FO[0-9]{2}[0-9]{4}[0-9]{9}[0-9]{1}',
    FR: 'FR[0-9]{2}[0-9]{5}[0-9]{5}[A-Z0-9]{11}[0-9]{2}',
    GB: 'GB[0-9]{2}[A-Z]{4}[0-9]{6}[0-9]{8}',
    GE: 'GE[0-9]{2}[A-Z]{2}[0-9]{16}',
    GI: 'GI[0-9]{2}[A-Z]{4}[A-Z0-9]{15}',
    GL: 'GL[0-9]{2}[0-9]{4}[0-9]{9}[0-9]{1}',
    GR: 'GR[0-9]{2}[0-9]{3}[0-9]{4}[A-Z0-9]{16}',
    GT: 'GT[0-9]{2}[A-Z0-9]{4}[A-Z0-9]{20}',
    HR: 'HR[0-9]{2}[0-9]{7}[0-9]{10}',
    HU: 'HU[0-9]{2}[0-9]{3}[0-9]{4}[0-9]{1}[0-9]{15}[0-9]{1}',
    IE: 'IE[0-9]{2}[A-Z]{4}[0-9]{6}[0-9]{8}',
    IL: 'IL[0-9]{2}[0-9]{3}[0-9]{3}[0-9]{13}',
    IS: 'IS[0-9]{2}[0-9]{4}[0-9]{2}[0-9]{6}[0-9]{10}',
    IT: 'IT[0-9]{2}[A-Z]{1}[0-9]{5}[0-9]{5}[A-Z0-9]{12}',
    KW: 'KW[0-9]{2}[A-Z]{4}[0-9]{22}',
    KZ: 'KZ[0-9]{2}[0-9]{3}[A-Z0-9]{13}',
    LB: 'LB[0-9]{2}[0-9]{4}[A-Z0-9]{20}',
    LI: 'LI[0-9]{2}[0-9]{5}[A-Z0-9]{12}',
    LT: 'LT[0-9]{2}[0-9]{5}[0-9]{11}',
    LU: 'LU[0-9]{2}[0-9]{3}[A-Z0-9]{13}',
    LV: 'LV[0-9]{2}[A-Z]{4}[A-Z0-9]{13}',
    MC: 'MC[0-9]{2}[0-9]{5}[0-9]{5}[A-Z0-9]{11}[0-9]{2}',
    MD: 'MD[0-9]{2}[A-Z0-9]{20}',
    ME: 'ME[0-9]{2}[0-9]{3}[0-9]{13}[0-9]{2}',
    MK: 'MK[0-9]{2}[0-9]{3}[A-Z0-9]{10}[0-9]{2}',
    MR: 'MR13[0-9]{5}[0-9]{5}[0-9]{11}[0-9]{2}',
    MT: 'MT[0-9]{2}[A-Z]{4}[0-9]{5}[A-Z0-9]{18}',
    MU: 'MU[0-9]{2}[A-Z]{4}[0-9]{2}[0-9]{2}[0-9]{12}[0-9]{3}[A-Z]{3}',
    NL: 'NL[0-9]{2}[A-Z]{4}[0-9]{10}',
    NO: 'NO[0-9]{2}[0-9]{4}[0-9]{6}[0-9]{1}',
    PK: 'PK[0-9]{2}[A-Z]{4}[A-Z0-9]{16}',
    PL: 'PL[0-9]{2}[0-9]{8}[0-9]{16}',
    PS: 'PS[0-9]{2}[A-Z]{4}[A-Z0-9]{21}',
    PT: 'PT[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{11}[0-9]{2}',
    RO: 'RO[0-9]{2}[A-Z]{4}[A-Z0-9]{16}',
    RS: 'RS[0-9]{2}[0-9]{3}[0-9]{13}[0-9]{2}',
    SA: 'SA[0-9]{2}[0-9]{2}[A-Z0-9]{18}',
    SE: 'SE[0-9]{2}[0-9]{3}[0-9]{16}[0-9]{1}',
    SI: 'SI[0-9]{2}[0-9]{5}[0-9]{8}[0-9]{2}',
    SK: 'SK[0-9]{2}[0-9]{4}[0-9]{6}[0-9]{10}',
    SM: 'SM[0-9]{2}[A-Z]{1}[0-9]{5}[0-9]{5}[A-Z0-9]{12}',
    TN: 'TN59[0-9]{2}[0-9]{3}[0-9]{13}[0-9]{2}',
    TR: 'TR[0-9]{2}[0-9]{5}[A-Z0-9]{1}[A-Z0-9]{16}',
    VG: 'VG[0-9]{2}[A-Z]{4}[0-9]{16}',
};

const formatIban = {
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    I: 18,
    J: 19,
    K: 20,
    L: 21,
    M: 22,
    N: 23,
    O: 24,
    P: 25,
    Q: 26,
    R: 27,
    S: 28,
    T: 29,
    U: 30,
    V: 31,
    W: 32,
    X: 33,
    Y: 34,
    Z: 35,
};

export default class Iban extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        ibanNotSupported: 'Unbekanntes Land in der IBAN "%value%"',
        ibanSepaNotSupported: 'Länder außerhalb des einheitlichen Euro-Zahlungsverkehrsraums (SEPA) werden nicht unterstützt',
        ibanFalseFormat: 'Die Eingabe weist ein ungültiges IBAN Format auf',
        ibanCheckFailed: 'Die IBAN-Prüfung ist fehlgeschlagen',
    };

    run()
    {
        if ('string' !== typeof this.value)
        {
            this.error = this.getMessage('ibanFalseFormat');
            return;
        }

        let value = this.value.toUpperCase().replace(/\s/g, '');

        let countryCode = this.countryCode;
        if (!countryCode)
        {
            countryCode = value.substr(0, 2);
        }

        if (-1 === Object.keys(ibanRegex).indexOf(countryCode))
        {
            this.error = this.getMessage('ibanNotSupported');
            return;
        }

        if (!this.allowedNonSepa && -1 === sepaCountries.indexOf(countryCode))
        {
            this.error = this.getMessage('ibanSepaNotSupported');
            return;
        }

        if (!value.match(new RegExp(`^${ibanRegex[countryCode]}$`)))
        {
            this.error = this.getMessage('ibanFalseFormat');
            return;
        }

        let format = value.substr(4) + value.substr(0, 4);
        format = format.replace(new RegExp(`(${Object.keys(formatIban).join('|')})`, 'g'), m => formatIban[m]);

        let temp = parseInt(format.substr(0, 1));

        let length = format.length;
        for(let i = 1; i < length; ++i)
        {
            temp *= 10;
            temp += parseInt(format.substr(i, 1));
            temp %= 97;
        }

        if(temp !== 1)
        {
            this.error = this.getMessage('ibanCheckFailed');
        }
    }

    get countryCode()
    {
        return this._options && this._options.countryCode ? this._options.countryCode : null;
    }

    get allowedNonSepa()
    {
        return this._options && this._options.allowedNonSepa;
    }
}